<template>
  <mu-flex class="is-full-width">
    <div style="width: 100%;height:100%;">
      <mu-flex direction="column" style="width: 100%;height: 100%;">
        <mu-flex class="is-full-width">
          <mu-card-media v-bind:title="totalmoney" sub-title="total assets" style="width: 100%;">
            <!-- <img src="../assets/image/index_bg.bcaa64c.png"> -->
            <img src="../assets/image/index_bg.bcaa64c.png" />
          </mu-card-media>
        </mu-flex>

        <!-- <mu-flex class="is-full-width" fill> -->
        <mu-flex class="is-full-width content" fill style="overflow-y: auto;">
          <template>
            <mu-load-more @refresh="refresh" :refreshing="refreshing" :loading="loadings" :loaded-all="loadedall"
              @load="loadsss" style="width: 100%">
              <el-table :data="tableData" :show-header="false" style="width: 100%"
              @row-click="SelectLine" empty-text="wait">
                <el-table-column>
                  <template slot-scope="scope">
                    <mu-flex class="is-full-width" fill>
                      <!-- <div class="product f-row"> -->
                      <!-- <img :src="getImage(scope.row)"> -->
                      <!-- <img src="../assets/image/btn_3_0.png" style="height: 100%;width: 50px;transform: translateY(25%);"/> -->
                      <img :src="imageList[scope.row.image]" style="height: 100%;width: 50px;align-self: center;" />
                      <div class="detail" style="width: 100%;margin-left: 10px;">

                        <div style="display: flex;justify-content: space-between;">
                          <p style="width: 50%;font-weight: bold;">
                            <font color="#303644">{{scope.row.Name}}</font>
                          </p>
                          <p style="width: 50%;text-align: right;font-weight: bold;">
                            <font color="#303644">{{scope.row.Num}}</font>
                          </p>
                        </div>
                        <div style="display: flex;justify-content: space-between;">
                          <p style="width: 50%;font-size: 2">
                            <font color="#DCDCDC">$</font> {{scope.row.Money}}
                          </p>
                          <p style="width: 50%;font-size: 2;text-align: right;">
                            <font color="#DCDCDC">≈$</font> {{scope.row.USDT}}
                          </p>
                        </div>
                      </div>
                      <!-- </div> -->
                    </mu-flex>
                  </template>
                </el-table-column>
              </el-table>
            </mu-load-more>
          </template>
        </mu-flex>
        <!-- </mu-flex> -->

      </mu-flex>
    </div>
    <label class="lbitText">&#160;localbitcoins&#160;</label>
  </mu-flex>
</template>

<script>
  import jquery from 'jquery'
  import {
    lStorage,
    sStorage
  } from "@Comm/js/Storage.js"
  export default {
    data() {
      return {
        //表格
        tableData: [],
        pageIndex: 1,
        //下拉刷新，上拉加载
        refreshing: false,
        loadings: false,
        loadedall: false,
        //总价格
        totalmoney: "$0.00",

        //图片列表
        imageList: [
          require('../assets/image/ETC.png'),
          require('../assets/image/USDT.80ed764.png'),
          require('../assets/image/BTC.4f04191.png')
        ]
      }
    },
    mounted() {
      // document.getElementById("totalmoney")..title="abcd";
      // $(".mu-card-title").val("你需要赋的值");

      // const that = this;
      // jquery(window).on("load", function() {
      //   console.log("--------");
      //   // console.log(that.$refs.multipleTable);
      //   // console.log(that.$refs.muTable.clientHeight);
      //   // that.$refs.multipleTable.style.maxHeight = this.$refs.muTable.clientHeight;
      // })
      this.refresh();

      setInterval(() => { //setInterval换个名字就行了
      // console.log(this.$route.path);
      if (this.$route.path!='/M/Home') return;
        this.refresh();
      }, 10 * 1000) //设置时间，这里是10秒
    },
    methods: {
      // back() {
      //   this.$router.go(-1); //返回上一层
      //   // history.back(-1);
      // },

      loadData() {
        const that = this;
		let params = new URLSearchParams();
		params.append('token',sStorage.getItem("token"));
        this.$http.get('/user/UserHome', {
            params
          })
          .then(function(response) {
            that.refreshing = false;
            if (response.data.success || response.data.code == 1) {
              // window.login.$message(response.data.message);
            var content = response.data.content;
            that.totalmoney = "$" + content.totalMoney;
            // that.cancelable=false;
            that.tableData = [{
                Name: "ETH",
                Num: content.ETHNum,
                Money: content.ETH,
                USDT: content.ETHUSDT,
                image: 0
              },
              {
                Name: "USDT",
                Num: content.USDTNum,
                Money: content.USDT,
                USDT: content.USDTUSDT,
                image: 1
              },
              {
                Name: "BTC",
                Num: content.BTCNum,
                Money: content.BTC,
                USDT: content.BTCUSDT,
                image: 2
              }
            ];
              // that.$message(response.data.message);
            } else if (response.data.code == -1){
              sStorage.clear();
              that.$router.replace("/");
              that.$message.error(response.data.message);
            } else {
              that.$message.error(response.data.message);
            }
          });
      },

      //下拉刷新数据
      refresh() {
        this.refreshing = true;
        this.pageIndex = 1;
        this.loadData();
        // var UserInfo = JSON.parse(sStorage.getItem("UserInfo"));
        // console.log(UserInfo.bTC);
        // this.tableData = [{Name:"ETH",money:UserInfo.bTC,image: 0}];
        // this.refreshing = false;
        // this.loadShipList(20, this.pageIndex);

      },
      //上拉加载数据
      loadsss() {
        this.loadings = true;
        this.pageIndex++;
        console.log(this.pageIndex);
        // this.loadShipList(20, this.pageIndex);
      },
      SelectLine(row, col, event) {
        console.log(row.Name);
        console.log(row.Num);
        console.log(row.USDT);
        this.$router.push({
          path: '/M/ExtractHome',
          query: {
            Name:row.Name,
            Num: row.Num,
            USDT: row.USDT
          }
        })
      }
    }
  };
</script>

<style>
  #Home * {
    touch-action: none;

  }

  #Home .lbitText {
    margin-top: 25px;
    margin-right: 10px;
    margin-left: 65%;
    z-index: 1;
    float: right;
    position: absolute;
    background-color: #ffffff;
    border-radius: 5px;
  }

  #Home .mu-card-media>img {
    border-radius: 5px;
    /* background: url("../assets/image/index_bg.bcaa64c.png") no-repeat center; */
    width: 500px;
    height: 150px;
  }

  #Home .mu-card-media-title {
    background-color: rgba(0, 0, 0, 0);
  }

  /* .headImage {
  } */
  #Home .el-table .cell {
    line-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/HomeList.vue